// Silences console output in production builds to avoid exposing data in browser dev tools
if (process.env.NODE_ENV === 'production') {
  const noop = () => {};
  // @ts-ignore
  window.console.log = noop;
  // @ts-ignore
  window.console.error = noop;
  // @ts-ignore
  window.console.warn = noop;
  // @ts-ignore
  window.console.info = noop;
  // @ts-ignore
  window.console.debug = noop;
}

export {}; 